import { createAction, createSlice } from '@reduxjs/toolkit';
import { TActionLoginWithEmailPayload, TLoginReducer } from './login.types';
import { requestStatusEnum } from '../store.types';


const initialState: TLoginReducer = {
  form: {
    email: '',
    password: '',
    remember_me: false,
    status: requestStatusEnum.INITIAL
  },
  error: { email: '', password: '' },
  userData: {
    accountStatus: '',
    orgId: '',
    role: '',
    userId: '',
    name: '',
  },
  userDataById: {
    data: {},
    status: requestStatusEnum.INITIAL
  },
};

const loginReducer = createSlice({
  name: 'loginReducer',
  initialState,
  reducers: {
    actionSubmitLogin(state, { payload }: TActionLoginWithEmailPayload) {
      state.form.status = requestStatusEnum.PROGRESS;
    },
    actionSubmitLoginSuccess(state) {
      state.form.status = requestStatusEnum.SUCCESS;
    },
    actionSubmitLoginFailed(state) {
      state.form.status = requestStatusEnum.FAILED;
    },
    submitLoginError(state, { payload }) {
      state.form.status = requestStatusEnum.FAILED;
      state.error = payload;
    },
    actionGetUserById(state, { payload }) {
      state.userDataById.status = requestStatusEnum.PROGRESS;
    },
    actionGetUserByIdSuccess(state, { payload }) {
      state.userDataById.status = requestStatusEnum.SUCCESS;
      state.userDataById.data = payload;
    },
    actionGetUserByIdFailed(state) {
      state.userDataById.status = requestStatusEnum.FAILED;
    },
    actionClearUserDataById(state) {
      state.userDataById.status = requestStatusEnum.INITIAL;
      state.userDataById.data = {};
    },
    
    // updateLoginInput(state, { payload }: TUpdateLoginInput) {
    //   state.form[payload.field] = payload.value;
    // },
    // updateLoginCheckbox(state, { payload }: TUpdateLoginCheckbox) {
    //   state.form.remember_me = payload;
    // },
    resetLogin() {
      return initialState;
    },
  },
})

export const {
    actionSubmitLogin,
    actionSubmitLoginSuccess,
    actionSubmitLoginFailed,
  actionGetUserById,
  actionGetUserByIdSuccess,
  actionClearUserDataById,
  actionGetUserByIdFailed
} = loginReducer.actions;

export default loginReducer.reducer

